import React from 'react';
import { ClipboardList, Store, Plus, Compass } from 'lucide-react';

import LinkButton from './LinkButton';
import css from './HowItWorks.module.css';

const OWNER_STEPS = [
  {
    title: 'Post your event RFP',
    body:
      'Share the date, city, guest count, and budget. Your RFP goes live to every matching provider in minutes, with no inbox sprawl.',
  },
  {
    title: 'Receive competitive bids',
    body:
      'Real bids land side by side: price, rating, distance, and match score. Message any provider, counter on price, and set your terms.',
  },
  {
    title: 'Accept & manage invoices',
    body:
      'Accept the winning bid, sign, and pay through Stripe. Track invoices, disputes, and bill reductions from one dashboard.',
  },
];

const PROVIDER_STEPS = [
  {
    title: 'Build your company profile',
    body:
      'Add your services, service radius, gallery, and FAQs. Your profile is what matches you to the right RFPs nearby.',
  },
  {
    title: 'Find matching events',
    body:
      'Browse live RFPs filtered to your area, dates, and booking minimum. New events land daily, so you can bid in 60 seconds.',
  },
  {
    title: 'Bid & get paid',
    body:
      'Send a priced offer, win the booking, and get paid within 24 hours of the last guest, overtime and extra expenses included.',
  },
];

const Track = ({ variant, Icon, role, title, steps, children }) => (
  <div className={variant === 'owner' ? css.trackOwner : css.trackProvider}>
    <div className={css.trackHead}>
      <div className={css.trackBadge}>
        <Icon />
      </div>
      <div>
        <div className={css.trackRole}>{role}</div>
        <div className={css.trackTitle}>{title}</div>
      </div>
    </div>
    <ol className={css.steps}>
      {steps.map((step, i) => (
        <li key={step.title} className={css.step}>
          <span className={css.stepNum}>{i + 1}</span>
          <div>
            <div className={css.stepTitle}>{step.title}</div>
            <p className={css.stepBody}>{step.body}</p>
          </div>
        </li>
      ))}
    </ol>
    <div className={css.trackCta}>{children}</div>
  </div>
);

const HowItWorks = () => {
  return (
    <section className={css.section} id="how">
      <div className={css.container}>
        <div className={css.head}>
          <span className={css.overline}>How does WLE work</span>
          <h2 className={css.title}>Two sides of the marketplace, two clear paths.</h2>
          <p className={css.sub}>
            Whether you're staffing an event or chasing your next booking, here's the whole journey,
            from post to payment, laid out for your side.
          </p>
        </div>

        <div className={css.tracks}>
          <Track
            variant="owner"
            Icon={ClipboardList}
            role="For Hiring Companies"
            title="Staff & equip your event"
            steps={OWNER_STEPS}
          >
            <LinkButton name="NewListingPage" variant="primary" className={css.fullBtn}>
              <Plus />
              Post an event
            </LinkButton>
          </Track>

          <Track
            variant="provider"
            Icon={Store}
            role="For Providers"
            title="Win & deliver event work"
            steps={PROVIDER_STEPS}
          >
            <LinkButton name="SignupPage" variant="secondary" className={css.fullBtn}>
              <Compass />
              Join as a Provider
            </LinkButton>
          </Track>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
